import { HttpClient, HttpEvent } from "@angular/common/http";
import { Observable } from "rxjs";
import { AuthService } from "./auth.service";
import { AbstractHttpService } from "./http-abstract.service";
import { Injectable } from "@angular/core";
import { AgentDto, ResultListDto } from "./dto";
import { BenefitPaymentApprovalSettingDto, PolicyBenefitPaymentDto, PolicyDto, ProductDto, PolicyScheduleUploadDto } from "./dto-insurance";

@Injectable({
	providedIn: 'root'
})
export class HttpInsuranceBenefitApprovalPaymentService extends AbstractHttpService {
	constructor(httpClient: HttpClient, authService: AuthService) {
		super(httpClient, '/api/gui/insurance/benefit-payment-approval', authService);
	}

	public getSettings(): Observable<BenefitPaymentApprovalSettingDto[]> {
		return super.doGet(true, `/settings`);
	}
	public modifySettings(payload: BenefitPaymentApprovalSettingDto[]): Observable<BenefitPaymentApprovalSettingDto[]> {
		return super.doPost(true, `/settings`, payload);
	}
	public getSettingAgents(): Observable<AgentDto[]> {
		return super.doGet(true, `/settingAgents`);
	}

	public getPendingBenefitPayments(pageIndex?: number, pageSize?: number): Observable<ResultListDto<PolicyBenefitPaymentDto>> {
		return super.doGet(true, `/pending?pageIndex=${pageIndex ?? 0}&pageSize=${pageSize ?? 20}`);
	}

	public getCurrentPaymentFileEntries(): Observable<PolicyBenefitPaymentDto[]> {
		return super.doGet(true, `/payment_file`);
	}
	public doSendPaymentFileToBank(): Observable<any> {
		return super.doPost(true, `/send_payment_file`,{});
	}
	public doSendPaymentLetter(ticket: string): Observable<any> {
		return super.doPost(true, `/send_payment_letter?ticket=${encodeURI(ticket)}`,{});
	}
	// public getPendingBenefitPayment(id: number): Observable<PolicyBenefitPaymentDto> {
	// 	return super.doGet(true, `/${id}`);
	// }
	// public getNextPendingBenefitPayment(offsetId?: number): Observable<PolicyBenefitPaymentDto> {
	// 	return super.doGet(true, `/next?currentId=${offsetId}`);
	// }
	public doApproval(payload: PolicyBenefitPaymentDto[], reason: string, pageSize?: number): Observable<ResultListDto<PolicyBenefitPaymentDto>> {
		return super.doPost(true, `/submit?pageIndex=0&pageSize=${pageSize ?? 20}&reason=${encodeURI(reason)}`, payload);
	}
}
